export default __webpack_public_path__ + "static/media/dm_khoa.ff3bed1c.xlsx";